import { Confirm, CustomDialog } from "react-st-modal";
import { ListItemIcon, MenuItem } from '@mui/material';
import OPERATION_ACCOUNTING_ACCOUNT from "./op_accounting_account";
import Edit from "../../../imgComponents/save.png";
import Delete from "../../../imgComponents/borrar.png";
import { refresh_token } from "../../../main_components/tokens/tokenrefresh";
import { accounting_account_delete } from "../../../services/finances/accounting_account";
import { findInObjectDisplayRole } from "../../../Content/verify_role";
const RENDER_ROW_ACTION_MENU_ITEMS = (props) => {

    const DeleteSector = async () => {
        props.setmodalT(true);
        try {
            var rf_token = await refresh_token();
            if (rf_token === true) {
                setTimeout(async () => {
                    try {
                        const d = await accounting_account_delete(props?.row?.original?.id);
                        props.alertas("Cuenta Contable Eliminada", true);
                        props.setmodalT(false);
                        props.handleSubmit();
                    } catch (err) {
                        console.log("error", err);
                        props.setmodalT(false);
                        props?.alertas(
                            err?.response?.data?.errorMessage?.es ?
                                err?.response?.data?.errorMessage?.es :
                                "Error inesperado, solicite soporte.",
                            false
                        )
                    }
                }, 1000);
            } else { }
        } catch (err) {
            console.log(err);
        }
    }


    return (
        <div>
            <MenuItem
                style={{ cursor: "pointer", display: findInObjectDisplayRole(["FI:AA1", "FI:AA3"]) }}
                key={1}
                onClick={async () => {
                    props.closeMenu();
                    const result = await Confirm('¿Esta usted seguro de eliminar la cuenta contable?', 'Eliminar Cuenta Contable', 'Si', 'No');
                    if (result) {
                        DeleteSector()
                    }
                }
                }
                sx={{ m: 0 }}
            >
                <ListItemIcon>
                    <img
                        alt=""
                        src={Delete}
                        title="Eliminar Cuenta Contable"
                        className=""
                    ></img>
                </ListItemIcon>
                Eliminar Cuenta Contable
            </MenuItem>
            <MenuItem
                style={{ cursor: "pointer", display: findInObjectDisplayRole(["FI:AA2", "FI:AA3"]) }}
                key={2}
                onClick={async () => {
                    props.closeMenu();
                    await CustomDialog(
                        <OPERATION_ACCOUNTING_ACCOUNT
                            operation={"EDIT"}
                            row={props?.row}
                            handleSubmit={props?.handleSubmit}
                            alertas={props?.alertas}
                            setmodalT={props.setmodalT}
                        />,
                        {
                            className: "custom-modal",
                            title: "EDITAR CUENTA CONTABLE",
                            showCloseIcon: true,
                        }
                    );
                }
                }
                sx={{ m: 0 }}
            >
                <ListItemIcon>
                    <img
                        alt=""
                        src={Edit}
                        title="Editar Cuenta Contable"
                        className=""
                    ></img>
                </ListItemIcon>
                Editar Cuenta Contable
            </MenuItem>

        </div >
    );
};

export default RENDER_ROW_ACTION_MENU_ITEMS;
